import React from 'react';
import styles from './Caption.module.css';

interface Props {
  position: number;
  name: string;
  location: string;
  nameHref: string;
  nameOnClick?: (event: React.SyntheticEvent<HTMLAnchorElement>) => void;
}

export function Caption(props: Props): React.ReactElement {
  return (
    <div className={styles.container}>
      <div className={styles.position}>{props.position}</div>
      <h2 className={styles.heading}>
        <a
          className={styles.headingAnchorTag}
          href={props.nameHref}
          onClick={props.nameOnClick}
        >
          {props.name}
        </a>
      </h2>
      <p className={styles.location}>{props.location}</p>
    </div>
  );
}
